var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M626.7 371c-41.9-27.2-91.5-43.3-141.1-48.9-50.3-5.6-101.3.7-149.5 14.7s-94.3 37.7-133.4 69.2c-19.6 16.1-37.7 33.5-53.8 53.1s-29.3 41.2-40.5 64.3c-2.8 6.3-.7 13.3 5.6 16.1s13.3.7 16.8-5.6c10.5-21 23.8-40.5 38.4-58.7 14.7-18.2 32.1-34.9 50.3-49.6 37-29.3 79.6-51.7 124.3-66.4 45.4-14.7 92.9-21 140.4-17.5s94.3 16.1 135.5 39.8c3.5 2.1 7 .7 9.1-2.1 2.1-2.1 1.4-6.3-2.1-8.4M101.3 220.2c-49.6 0-89.4 39.8-89.4 89.4s89.4 166.3 89.4 166.3 90.1-116.7 90.1-166.3c.1-48.9-40.5-89.4-90.1-89.4m0 142.5c-28.6 0-52.4-23.8-52.4-52.4s23.8-52.4 52.4-52.4 52.4 23.8 52.4 52.4-23 52.4-52.4 52.4m590.3-134.9c0-37.7-30.7-68.5-68.5-68.5s-68.5 30.7-68.5 68.5S623.2 355 623.2 355s68.4-88.7 68.4-127.2m-108.2 0c0-22.4 18.2-39.8 39.8-39.8 21.7 0 39.8 18.2 39.8 39.8 0 22.4-18.2 39.8-39.8 39.8-21.7.1-39.8-17.4-39.8-39.8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanner);
export default __webpack_public_path__ + "static/media/planner.82e73b98878c5a869ea08e26a62a7979.svg";
export { ForwardRef as ReactComponent };